<input #inputFromElement matInput class="atp-date-time-picker__input-from" [formControl]="formControlFrom"
       autocomplete="off" (click)="focus(inputFromElement, formControlFrom)" readonly>
<ng-container *ngIf="type.startsWith('Range')">
  <span class="atp-date-time-picker__separator">{{dateTimeService.getSplitDateTimeRange()}}</span>
  <input #inputToElement matInput class="atp-date-time-picker__input-to" [formControl]="formControlTo"
         autocomplete="off" (click)="focus(inputToElement, formControlTo)" readonly>
</ng-container>
